module.exports = __webpack_public_path__ + "img/vip.7a346a6f.png";